<template>
    <div>
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">Valentine's Day</span>
            </li>
        </ul>
        <main>
            <section class="slogan">
                <div class="container1366 section1-container">
                    <div class="section1-left">
                        <h1 class="section1-title">Share Love & Passion</h1>
                        <h2 class="section1-subtitle">Celebrate the magic of Valentine's Day with our carefully selected Valentine's Gifts</h2>
                    </div>
                    <div class="section1-right" v-if="!mobileCheck"></div>
                </div>
            </section>

            <section id="more-collections">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">Valentine's Gifts</h2>
                    <div class="title-border"></div>

                    <div class="christmas-wrapper">
                        <div class="christmas-title">Enjoy this limited time offer of Valentine's gifts all inclusive!</div>
                        <div class="christmas-bullets">
                            <div class="christmas-bullets-item christmas-bullets-item1"><div class="row-icon"></div>{{ $t("christmas-gift09") }}</div>
                            <div class="christmas-bullets-item christmas-bullets-item2"><div class="row-icon"></div>{{ $t("christmas-gift10") }}</div>
                            <div class="christmas-bullets-item christmas-bullets-item3"><div class="row-icon"></div>{{ $t("christmas-gift11") }}</div>
                        </div>
                    </div>

                    <ChristmasCollections class="home-more-collections" :useSlider="true"></ChristmasCollections>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChristmasCollections from "../components/home/ChristmasCollections";
import {GCommon, GOrders} from "@/store/getters";
import {AOrders} from "@/store/actions";
import {MOrders} from "~/store/mutations";

export default {
    name: 'collections',
    head: {
        title: 'Fine Wine Collections | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'collections-page christmas-page'
        }
    },
    components: {
        ChristmasCollections
    },
    data(){
        return {
            restCollectionsItems: []
        }
    },
    computed: {
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            collectionsList: GOrders.GET_COLLECTIONS
        })
    },
    methods: {
        getCollectionItems() {
            this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
                this.$store.commit(MOrders.SET_CHRISTMAS_COLLECTIONS2, this.collectionsList)
            });
        }
    },
    mounted() {
        this.getCollectionItems();

        this.$nuxt.$on('langUpdated', () => {
            this.getCollectionItems();
        })
    }
};
</script>

<style scoped>
.section1-left,
.section1-right {
    display: inline-block;
    width: calc((100% - 30px) / 2);
    vertical-align: top;
    height: 100%;
}
.section1-left {
    margin-right: 24px;
}
.section1-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    color: #FFFFFF;
    margin-bottom: 16px;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 20%;
}
.section1-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    color: #FFFFFF;
    margin-bottom: 32px;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.home ul {
    padding-left: 0;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.padding200 {
    padding: 0 200px;
}
.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}
.title-border {
    width: 64px;
    height: 4px;
    background: #ECD9A7;
    margin: 24px auto 16px;
}

.slogan {
    height: 458px;
    position: relative;
    background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0.00) 32.64%), url('../assets/gifts/valentine.jpg') no-repeat center;
    background-size: cover;
}

.main-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 50px;
    padding: 270px 0 24px 0;
    text-transform: capitalize;
    text-align: center;
    margin-bottom: 0;
    color: #FFFFFF;
}
html[lang=de] .main-title {
    text-transform: none;
}
.main-subtitle {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #FFFFFF;
    max-width: 918px;
    margin: 0 auto;
}
.christmas-wrapper {
    border-radius: 8px;
    background: url('../assets/gifts/valentines2.png') no-repeat center;
    background-size: cover;
    padding: 55px 32px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
    height: 256px;
}
.christmas-title {
    color: white;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    height: 20px;
    align-self: stretch;
}
.christmas-bullets {
    display: flex;
    align-items: flex-start;
    align-self: stretch;
}
.christmas-bullets-item {
    display: flex;
    gap: 8px;
    flex: 1 0 0;
    color: white;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    flex-direction: column;
    align-items: center;
}
.christmas-bullets-item .row-icon {
    height: 56px;
    width: 56px;
}
.christmas-bullets-item1, .christmas-bullets-item2 {
    border-right: 1px solid #ccc;
}
.christmas-bullets-item1 .row-icon {
    background: url('../assets/gifts/vat.png') no-repeat center;
    background-size: contain;
}
.christmas-bullets-item2 .row-icon {
    background: url('../assets/gifts/delivery.png') no-repeat center;
    background-size: contain;
}
.christmas-bullets-item3 .row-icon {
    background: url('../assets/gifts/eu.png') no-repeat center;
    background-size: contain;
}

/* START Top Collections */
.home-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    margin-bottom: 24px;
    position: relative;
    text-align: center;
}

/* END Top Collections */

#more-collections {
    background: #ebebeb url('../assets/gifts/snowflakes.png') no-repeat center bottom;
    background-size: cover;
}

@media(max-width: 767px) {
    .slogan {
        height: 250px;
        background-position-x: 100%;
        background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0.00) 100%), url('../assets/gifts/valentine.jpg') no-repeat center;
        background-size: cover;
    }
    .home-title {
        font-size: 20px;
        line-height: 24px;
    }
    .main-title {
        padding-top: 44px;
        font-size: 18px;
        line-height: 22px;
    }
    .main-subtitle {
        font-size: 16px;
        line-height: 20px;
        padding: 0 16px;
    }
    .home-tab-container .home-title {
        margin-top: 24px;
    }
    .home-tab-container .mobile-more-collections-wrapper .home-title {
        margin-top: 0;
    }
    .padding200 {
        padding-left: 16px;
        padding-right: 16px;
    }
    .padding80 {
        padding-top: 32px;
        padding-bottom: 32px;
    }
    .title-border {
        margin-bottom: 24px;
    }
    .christmas-wrapper {
        padding: 45px 12px;
        background-size: 400%;
        margin-bottom: 32px;
    }
    .christmas-title {
        height: auto;
    }
    .christmas-bullets-item {
        font-size: 13px;
    }
    .christmas-bullets-item .row-icon {
        height: 45px;
        width: 45px;
    }
    .christmas-bullets-item1,
    .christmas-bullets-item2 {
        padding-right: 6px;
    }
    .section1-container {
        height: 100%;
        padding: 16px;
        text-align: center;
    }
    .section1-left {
        width: 100%;
        margin: 0 auto;
        display: block;
    }
    .section1-left .home-section2-btn-wrapper {
        text-align: center;
    }
    .section1-title {
        font-size: 24px;
        line-height: 26px;
        margin-top: 90px;
    }
    .section1-subtitle {
        font-size: 16px;
        line-height: 20px;
    }
}
</style>
<style>
.collections-page .v-main {
    padding-top: 80px !important;
}
.christmas-page.collections-page ul.vindome-breadcrumbs {
    position: relative;
    background: #00304D;
    height: 24px;
    top: 0;
    left: 0;
    padding-left: 24px;
    padding-top: 6px;
    z-index: 9;
}
</style>
